import { Quarter } from '../../../planning/standard-review/standard.constants';

export { Quarter };

export enum IssueRating {
  Red = 'Red',
  Yellow = 'Yellow',
  Blue = 'Blue',
  Green = 'Green',
  NotRated = 'Not Rated',
}

export enum ActionRequiredBy {
  AccentureAndClient = 'Accenture and Client',
  Accenture = 'Accenture',
}

export enum RepLetterConflict {
  Yes = 'Yes',
  No = 'No',
  NotApplicable = 'Not Applicable',
}

export enum FinancialYear {
  FY21 = 'FY21',
  FY22 = 'FY22',
  FY23 = 'FY23',
  FY24 = 'FY24',
  FY25 = 'FY25',
  FY26 = 'FY26',
}

export enum ReportStatus {
  PreGoLive = 'Pre-Go Live',
  DraftNotPublished = 'Draft-Not Published',
  FinalPublished = 'Final-Published',
}

export const LOCATION_OPTIONS: readonly string[] = [

];

export const SERVICE_LINE_OPTIONS: readonly string[] = [
  
];

export const ISSUE_RATING_OPTIONS: readonly IssueRating[] = Object.values(IssueRating);
export const ACTION_REQUIRED_BY_OPTIONS: readonly ActionRequiredBy[] = Object.values(ActionRequiredBy);
export const REP_LETTER_CONFLICT_OPTIONS: readonly RepLetterConflict[] = Object.values(RepLetterConflict);
export const FINANCIAL_YEAR_OPTIONS: readonly FinancialYear[] = Object.values(FinancialYear);
export const QUARTER_OPTIONS: readonly Quarter[] = Object.values(Quarter);
export const REPORT_STATUS_OPTIONS: readonly ReportStatus[] = Object.values(ReportStatus);

export const REP_LETTER_QUESTIONS_OPTIONS: readonly string[] = [

];

export const ISSUE_FROM_GO_LIVE_OPTIONS: readonly string[] = [
  'Pre Go-live',
  'Post Go-live',
  'Pre Go-live & Post Go-live',
];

export const ACTION_PLAN_STATUS_OPTIONS: readonly string[] = [
  'Open', 'Open-Ageing & Static', 'Closed'
];

export const INTERNAL_DEPENDENCY_OPTIONS: readonly string[] = ['Dep 1', 'Dep 2'];

export const ACTION_PLAN_OWNER_OPTIONS: readonly string[] = ['sandesh', 'praful', 'laxmi'];

export const ALLOWED_FILE_EXTENSIONS: readonly string[] = [
  '.pdf', '.msg', '.xls', '.xlsx', '.doc', '.docx',
  '.txt', '.ppt', '.pptx', '.jpg', '.jpeg', '.png', '.zip',
];

export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;
